import React, { useState } from 'react';
import {
    User,
    Building2,
    Bell,
    Shield,
    Database,
    Sparkles,
    Mail,
    Phone,
    Briefcase,
    MapPin,
    Camera,
    Settings as SettingsIcon
} from 'lucide-react';
import './Settings.css';

const tabs = [
    { id: 'profile', label: 'Profile', icon: <User size={18} /> },
    { id: 'organization', label: 'Organization', icon: <Building2 size={18} /> },
    { id: 'notifications', label: 'Notifications', icon: <Bell size={18} /> },
    { id: 'integrations', label: 'Integrations', icon: <Database size={18} /> },
    { id: 'security', label: 'Security', icon: <Shield size={18} /> },
    { id: 'ai', label: 'AI Settings', icon: <Sparkles size={18} /> },
];

const Settings = () => {
    const [activeTab, setActiveTab] = useState('profile');

    return (
        <div className="settings-page">
            <header className="page-header">
                <div>
                    <h3>Settings</h3>
                    <p className="subtitle">Manage your account preferences and system configurations.</p>
                </div>
            </header>

            <div className="settings-container">
                <aside className="settings-sidebar">
                    {tabs.map(tab => (
                        <button
                            key={tab.id}
                            className={`settings-tab ${activeTab === tab.id ? 'active' : ''}`}
                            onClick={() => setActiveTab(tab.id)}
                        >
                            {tab.icon}
                            <span>{tab.label}</span>
                        </button>
                    ))}
                </aside>

                <main className="settings-content">
                    <div className="settings-form-container">
                        <div className="profile-header-settings">
                            <div className="settings-avatar-large">
                                <span>JS</span>
                                <button className="avatar-edit-btn"><Camera size={14} /></button>
                            </div>
                            <div className="profile-title-settings">
                                <h3>Jacob Shahjan</h3>
                                <p>Bid Manager • EDGE RFP Organization</p>
                                <div className="status-badge-small online">Online</div>
                            </div>
                        </div>

                        <div className="settings-grid">
                            <div className="form-group">
                                <label>Full Name</label>
                                <div className="input-wrap">
                                    <User size={18} className="input-icon" />
                                    <input type="text" defaultValue="Jacob Shahjan" />
                                </div>
                            </div>
                            <div className="form-group">
                                <label>Email Address</label>
                                <div className="input-wrap">
                                    <Mail size={18} className="input-icon" />
                                    <input type="email" defaultValue="jacob@velocityrfp.ai" />
                                </div>
                            </div>
                            <div className="form-group">
                                <label>Phone Number</label>
                                <div className="input-wrap">
                                    <Phone size={18} className="input-icon" />
                                    <input type="text" defaultValue="+1 (555) 0123-4567" />
                                </div>
                            </div>
                            <div className="form-group">
                                <label>Department</label>
                                <div className="input-wrap">
                                    <Briefcase size={18} className="input-icon" />
                                    <input type="text" defaultValue="Bid Management" />
                                </div>
                            </div>
                            <div className="form-group">
                                <label>Job Title</label>
                                <div className="input-wrap">
                                    <SettingsIcon size={18} className="input-icon" />
                                    <input type="text" defaultValue="Senior Bid Manager" />
                                </div>
                            </div>
                            <div className="form-group">
                                <label>Location</label>
                                <div className="input-wrap">
                                    <MapPin size={18} className="input-icon" />
                                    <input type="text" defaultValue="New York, USA" />
                                </div>
                            </div>
                        </div>

                        <div className="settings-actions">
                            <button className="secondary-btn">Cancel</button>
                            <button className="primary-btn">Save Changes</button>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default Settings;
